import { Component } from '@angular/core';
import {Token} from "../../auth/models/token";
import {AuthService} from "../../auth/services/auth-service";

@Component({
    selector: 'app-inicial',
    templateUrl: './inicial.component.html',
    styleUrl: './inicial.component.css',
    standalone: false
})
export class InicialComponent {
  token: Token | undefined;
  usuario = "";

  constructor(private tokenService: AuthService) {
    this.token = this.tokenService.AccessToken;
    this.usuario = this.token?.nome ?? '';
  }
}
